<template>
  <div class="content">
    <div class="shop-box" v-if="skeletonShow">
      <div class="sk-search-box"></div>
      <div class="skeleton shop-list"  :loading="skeletonShow">
        <div class="shop-item shop-item-sec" v-for="index in 12" :key="index">
          <div class="shop-item-sec-content"><van-skeleton :row="5" /></div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="search-box justify-align">
        <img @click="onClickLeft" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="" />
        <div class="search-box-sec left-justifying">
          <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
          <div class="searchInput" @click="goSearch"> 搜一搜</div>
        </div>
      </div>
      <van-list v-if="list.length"
                v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList" offset="10">
        <div class="classify-box">
          <!--        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">-->
          <!--          <van-swipe-item v-for="(image, index) in banner" :key="index"><img class="cover-img" src="../../assets/img.png" /></van-swipe-item>-->
          <!--        </van-swipe>-->
          <div class="shop-box">
            <div class="shop-list">
              <div class="shop-item" v-for="(item,index) in list" :key="index">
                <div class="shop-item-box">
                  <img class="shop-img" @click="goDes(item.id)" v-lazy="item.image" alt="">
                  <div class="title" @click="goDes(item.id)">
                    <!--                  <div class="tag">￥1</div> -->
                    {{item.name}}</div>
                  <div class="price-box justify-align">
                    <div class="price" @click="goDes(item.id)">￥{{item.price}}</div>
                    <img @click="shareClick(item)" :src="require('../../assets/'+appTheme+'/share_icon.png')" alt="" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div style="text-align: center;margin-top: 20vw;" v-else>暂无数据</div>
      <div class="null-box"></div>
      <!--    分享弹框-->
      <van-overlay :show="shareShow">
        <div class="wrapper" @click.stop>
          <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
          <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
          <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
            <img class="img-goods goodsImg" :src="shareItem.image" alt="" />
            <div class="title">{{shareItem.name}}</div>
            <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
            <div class="hint">长按二维码保存图片</div>
          </div>

        </div>
      </van-overlay>
      <!--    分享商品-->
      <div class="hidden" style="display: none;">
        <!--    width: 69.33333vw; height: 118.66667vw;-->
        <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      </div>
      <!--    分享商品end-->
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
export default {
  name: "classifyList",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      activeNav: 0,
      searchValue: '',
      active: 0,
      list: [],
      banner: [{},{}, {}, {}],
      curr: 0,
      category_id: '',
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      valueSearch: '',
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      shareShow:false,
      painting:{
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px'
      },
      skeletonShow: true, // 骨架屏
    }
  },
  components: {
    VueCanvasPoster
  },
  created() {
    var id = this.$route.query.id
    this.category_id = id
    // this.getCategory()
    var value = this.$route.query.value
    console.log('value', value)
    if (value != undefined){ //搜索进来
      console.log('有值')
      this.valueSearch = value
    } else {
      console.log('没有值')
      this.getGoodList()
    }
  },
  methods:{
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    shareShowHide(){
      this.shareItem = ''
      this.shareGoodsImg = ''
      this.qrcodeUrl = ''
      this.shareShow = false
      console.log(this.qrcodeUrl)
      console.log('shareItem',this.shareItem)
    },
    shareClick(goods){ // 生成二维码
      console.log(goods)
      var that = this
      that.shareItem = goods
      that.shareGoodsImg = goods.image
      var id = goods.id
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/goodDetails?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'

      console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          that.qrcodeUrl = qr;
          console.log('qrcode',that.qrcodeUrl)
          this.shareShow = true

          this.drawPoster(qr)
        }
      });
      this.drawPoster()
    },
    drawPoster(qr){
      var that = this

      var total = this.shareItem.price * 0.95
      var price = total.toFixed(2);
      var discount = '折后优惠价：'+price
      this.painting = {
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '876px',
              right: '9px',
              bottom: '6px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: that.shareGoodsImg,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '370px',
              height: '370px',
              top: '50px',
              left: '75px'
            }
          },
          {
            type: 'text',
            text: this.shareItem.name,
            css: [
              {
                top: '450px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px'
              }
            ]
          },
          {
            type: 'image',
            url: that.qrcodeUrl, // this.qrcodeUrl, //
            css: {
              width: '170px',
              height: '170px',
              top: '570px',
              left: '175px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "780px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          },
          // {
          //   type: 'rect',
          //   css: {
          //     width: '503px',
          //     height: '106px',
          //     right: '9px',
          //     bottom: '70px',
          //     color: '#feeb86',
          //
          //   }
          // },
          // {
          //   type: "text",
          //   text: "扫码购买立即享受95折",
          //   css: {
          //     bottom: "135px",
          //     left: "136px",
          //     width: "360px",
          //     maxLines:1,
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
          // {
          //   type: "text",
          //   text: discount, // 扫码购买立即享受95折 折后优惠价：15.2
          //   css: {
          //     bottom: "90px",
          //     left: "134px",
          //     width: "260px",
          //     maxLines:1,
          //     textAlign: 'center',
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
    goSearch(){
      this.$router.push('/searchList');
    },
    async getCategory () {
      const res = await this.$Http.getCategoryList()
      if (res.code == 200){
        console.log('res',res)
        this.navList = res.data
        this.getGoodList()
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    async getGoodList () {
      var that = this
      var data ={
        category_id: this.category_id,
        page: 1
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        // console.log('res',res)
        this.list = res.data.data
        // console.log(this.list)
        // 加载状态结束
        this.loading = false;
        if (res.data.data.length == res.data.total){ // 数据全部加载完
          this.finished = true; // 数据全部加载完
          console.log('不加载')
          if(res.data.data==0){
            this.finishedTxt = '暂无数据~'
          } else {
            this.finishedTxt = '没有更多了~'
          }
        }else {
          that.finished = false; // 不可以加载
        }
        this.skeletonShow = false
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    async moreList(){
      var that = this
      this.currentPage += 1;//页数+1

      var data ={
        category_id: this.category_id,
        page: this.currentPage
      }
      const res = await this.$Http.getGoodsList(data)
      // 加载状态结束
      this.loading = false;
      if (res.code == 200){
        // console.log('res',res.data.data)
        var arr = this.list.concat(res.data.data);
        // console.log(arr.length)
        that.list = arr
        // console.log('total',res.data.total + 'list'+ this.list.length)
        if (that.list.length == res.data.total) { // 数据全部加载完成
          this.finished = true;
          // console.log('加载完毕')
        } else {
          this.finished = false;
        }
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    goDes(id){
      this.$router.push({path:'/goodDetails',query: {id: id}})
    },
    onClick(name, title){
      console.log(title)
    },
    searchClick(){
      console.log(this.searchValue)
      this.$router.push({path:'/searchList',query: {value:this.searchValue}})
    }
  }
}
</script>

<style lang="scss" scoped>

/deep/.van-tab--active {
  font-weight: bold;
  color: #F23926;font-size: 32px;
}
.my-swipe{
  width: 695px;margin: 24px auto 12px;
  img{
    width: 100%; height: 264px;display: block;
  }
}
.my-swipe .van-swipe-item {
  height: 264px;
}
//.search-box{
//  padding: 34px 42px 34px 27px;
//  background: #FDD80D;
//  img{
//    width: 22px;height: auto;display: inline-block;
//  }
//  .search-box-sec{
//    width: 680px;
//    height: 60px;
//    line-height: 60px;color: #8C8C8C;font-size: 24px;
//    background: #FFFFFF;
//    opacity: 0.63;
//    border-radius: 30px;text-align: left;padding-left: 28px;
//    img{
//      width: 34px;height: auto;display: inline-block;
//    }
//    .searchInput{
//      height: 60px;
//      line-height: 60px;width: 500px;margin-left: 10px;border: none;background: none;color: #282828;font-size: 28px;
//    }
//  }
//}
.search-box{
  padding: 34px 42px 34px 27px;
  background: #FDD80D;
  img{
    width: 22px;height: auto;display: inline-block;
  }
  .search-box-sec{
    width: 590px;
    height: 60px;
    line-height: 60px;color: #8C8C8C;font-size: 24px;
    background: #FFFFFF;
    opacity: 0.63;
    border-radius: 30px;text-align: left;padding-left: 28px;
    img{
      width: 34px;height: auto;display: inline-block;
    }
    .searchInput{
      height: 60px;
      line-height: 60px;width: 500px;margin-left: 10px;border: none;background: none;color: #282828;font-size: 28px;
    }
  }
}
.shop-box{
  font-size: 28px;
  .shop-list{
    padding: 0 24px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    .shop-item{
      width: 50%;text-align: center;margin-bottom: 20px;overflow:hidden;
      .shop-item-box{
        margin: 16px 0;background: #ffffff;border-radius: 10px;
      }
      .shop-img{
        width: 100%;
        height: 343px;
      }
      .title{
        margin-top: 30px;font-size: 28px;font-weight: bold;
        color: #000000;text-align: left;padding: 0 10px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        .tag{
          display: inline-block;background: #F23926;
          border-radius: 5px;padding: 0 10px;font-size: 18px;color: #FFFFFF;font-weight: bold;
        }
      }
      .price-box{
        padding: 15px 10px 15px;
        .price{
          font-weight: bold;
          color: #F23926;font-size: 32px;
        }
        img{
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
.shop-box .shop-list .shop-item:nth-child(odd) .shop-item-box{
  margin-right: 20px;
}
.shop-box .shop-list .shop-item:nth-child(even) .shop-item-box{
  //margin-left: 20px;
}

.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 80px auto 30px;
  }
  .imageWrapper{
    background: #fff;width: 520px;margin: 0 auto;padding: 10px;text-align: center;
    border: 6px solid #FDD80D;
    border-radius: 20px;
  }
  img{
    width: 520px;display: block;height: auto;margin: 0 auto;
  }
  .goodsImg{
    width: 370px;
    height: 370px;
    border-radius: 10px;margin-top: 30px;
  }
  .title{
    width: 370px;margin:20px auto;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .qr-code-img{
    width: 175px;height: 175px;
  }
  .hint{
    padding-bottom: 20px;
  }
}
.sk-search-box{
  margin: 30px 30px 30px;
  border-radius: 35px;
  background-color: #d4d3d3;
  height: 80px;

}
.shop-item-sec{

  .shop-item-sec-content{
    height: 390px;
    margin: 0px 16px;
    //background-color: #e0e0e0;
    border-radius: 10px;
  }
}
/deep/.van-skeleton__row, .van-skeleton__title{
  height: 390px;width: 100%;background-color: #d4d3d3;
  border-radius: 20px;
}
/deep/.van-skeleton{
  padding: 0;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
